
<template>
<div>
  <div :class="ehCadastro ? 'container' : ''">
    <iframe
      v-if="!ehCadastro"
      :src="(idioma === 0) ? '/html/termos.html' : '/html/termos-en.html'"
      :height="$vuetify.breakpoint.height - marginTopNumber - heightCalcCorrecao"
      :style="`margin-top: ${marginTopNumber}px;`"
      class="responsive-iframe"
      width="100%"
      frameborder="0"
      scrolling="auto"/>
    <iframe
      v-else
      :src="(idioma === 0) ? '/html/termos.html' : '/html/termos-en.html'"
      height="100%"
      class="responsive-iframe"
      width="100%"
      frameborder="0"
      scrolling="auto"/>
  </div>
  <v-layout v-if="user && !ehCadastro" style="bottom: 0; position: fixed; background: #fff; width: 100%">
      <v-btn flex small @click="verDetalhes = !verDetalhes">{{verDetalhes ? strings[idioma].fechar : strings[idioma].ver_detalhes}}</v-btn>
      <template v-if="verDetalhes">
        <v-flex xs6>
          <v-checkbox v-model="user.aceite_termos" small disabled :label="strings[idioma].aceito + ' ' +strings[idioma].termos_de_uso"></v-checkbox>
        </v-flex>
      </template>
    </v-layout>
</div>
</template>
<style scoped>
.container {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}

/* Then style the iframe to fit in the container div with full height and width */
.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  min-height: 200px;

}
</style>
<script>
import { mapState } from 'vuex'
export default {
  props: {
    ehCadastro: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      verDetalhes: false
    }
  },
  computed: {
    ...mapState('app', ['idioma', 'strings', 'user']),
    heightOverflow () {
      return (
        'height: ' +
        String(this.$vuetify.breakpoint.height) +
        'px; overflow: auto;'
      )
    },
    heightCalcCorrecao () {
      return (
        this.user === null ? 0 : 50
      )
    },
    marginTopNumber () {
      return (
        this.user === null ? 60 : 0
      )
    }
  },
  methods: {
    voltar () {
      const length = history.length
      if (length <= 1) {
        window.close()
      } else {
        window.history.back()
      }
    }
  }

}
</script>
